import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';
import Icon from './Icon';

function NavBar({ title = "MindBridge" }) {
  const navigate = useNavigate();

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '12px 20px',
      backgroundColor: '#4361ee',
      color: 'white',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    }}>
      <Button 
        onClick={() => navigate(-1)}
        variant="outline"
        style={{
          backgroundColor: 'transparent',
          border: '1px solid rgba(255,255,255,0.3)',
          color: 'white',
          padding: '8px 16px',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        <Icon name="back" size={16} color="white" />
        Back
      </Button>
      
      <h2 
        onClick={() => navigate('/home')}
        style={{ 
          margin: 0, 
          fontSize: '18px', 
          cursor: 'pointer',
          textDecoration: 'none',
          color: 'white',
          fontWeight: '600'
        }}
      >
        {title}
      </h2>
      
      <Button 
        onClick={() => navigate('/home')}
        variant="success"
        style={{
          padding: '8px 16px',
          fontSize: '14px',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}
      >
        <Icon name="home" size={16} color="white" />
        Home
      </Button>
    </div>
  );
}

export default NavBar;